export const apiBasePath = (_lang?: string) => {
	switch (window.location.hostname) {
		case '127.0.0.1':
			return `http://127.0.0.1:8080`;
		case 'localhost':
			return `https://ems.codito.cz`;
		default:
			return 'https://' + window.location.hostname;
	}
}

export const isProdEnv = !['localhost', 'ems.codito.cz', '127.0.0.1'].includes(window.location.hostname);

const path = window.location.pathname;
export const isRsvp = path.startsWith('/rsvp/') || path.startsWith('/info/') || path.startsWith('/plan/') || path.startsWith('/ammo');
export const isPublic = path.startsWith('/registration') || path.startsWith('/confirmation');
export const baseUrl = '/';
